"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Collapse.default;
  }
});
Object.defineProperty(exports, "unstable_StrictModeCollapse", {
  enumerable: true,
  get: function get() {
    return _StrictModeCollapse.default;
  }
});

var _Collapse = _interopRequireDefault(require("./Collapse"));

var _StrictModeCollapse = _interopRequireDefault(require("./StrictModeCollapse"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Collapse/index.js
// module id = 70
// module chunks = 0